<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <title-text>Referrals.</title-text>
      </v-col>
      <v-col cols="12" md="12">
        <v-card
          flat
          class="rounded-lg primary--border pa-8"
          color="#FFF9F2"
          min-height="280"
          width="100%"
        >
          <div class="text-h5 font-weight-bold">Share</div>
          <div class="d-flex mt-5">
            <v-card
              flat
              class="rounded-circle mr-3 pa-2"
              color="secondary"
              v-for="(social, ix) in socials"
              :key="ix"
            >
              <share-network
                class="text-none text-decoration-none"
                :network="social.network != 'instagram' ? social.network : ''"
                url="app.homify.ng"
                title="Affordable Luxury for Everyone"
                description="Homify provides opportunity for you to enjoy luxurious smarthomes with flexible payment plan spread across 3 years at an affordable rate."
                quote="Think Luxury, Think Homify"
                hashtags="homify,investment,pertinence"
              >
                <v-icon size="25" color="primary">{{ social.icon }}</v-icon>
              </share-network>
            </v-card>
            <v-card
              @click="openPage('https://www.instagram.com/homifyng/')"
              flat
              class="rounded-circle mr-3 pa-2"
              color="secondary"
            >
              <v-icon size="25" color="primary">mdi-instagram</v-icon>
            </v-card>
          </div>
          <div class="mt-8 text-h6 font-weight-light">
            Share your referral link or code. You can earn up to 5% when you
            refer anyone who invests in any of our offers
          </div>
          <v-card tile class="mt-8" color="#F2F2F2" flat width="100%">
            <v-row justify="space-between" no-gutters>
              <v-col cols="12" md="10">
                <div
                  class=" px-4 text-wrap"
                  :class="{ 'px-4': $vuetify.breakpoint.mdAndDown }"
                >
                <v-text-field readonly background-color="transparent" id="ref-link2" solo flat hide-details
                  class=" text-h6 font-weight-bold text-wrap"
                  :value="userObj.referralcode
                      ? `https://app.homify.ng/r/${userObj.referralcode}/`
                      : 'Loading...'"
                >
                  
                </v-text-field>
                 
                </div>
              </v-col>
              <v-col cols="12" md="2">
                <v-btn
                  @click="copyLink"
                  tile
                  :disabled="!userObj.referralcode"
                  :height="$vuetify.breakpoint.smAndDown ? '80px' : '100%'"
                  block
                  depressed
                  color="primary"
                  class="text-none"
                >
                  <div class="d-flex">
                    <hm-icon class="mr-2">
                      <copy-icon></copy-icon>
                    </hm-icon>
                    <span>{{ isCopied ? "Copied!" : "Copy" }}</span>
                  </div>
                </v-btn>
              </v-col>
            </v-row>
          </v-card>
        </v-card>
      </v-col>
      <v-col>
        <referrals-table />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import TitleText from "@/components/dashboard/DbTitleText.vue";
import HmIcon from "@/components/HmIcon.vue";
import CopyIcon from "@/components/icons/CopyIcon.vue";
import { mapState } from "vuex";
import ReferralsTable from "@/components/referrals/ReferralsTable";

export default {
  components: {
    TitleText,
    CopyIcon,
    HmIcon,
    ReferralsTable
  },
  data() {
    return {
      isCopied: false,

      socials: [
        {
          icon: "mdi-facebook",
          network: "facebook",
        },
        {
          icon: "mdi-twitter",
          network: "twitter",
        },
        // {
        //   icon: "mdi-instagram",
        //   network: "instagram",
        // },
      ],
    };
  },
  computed: {
    ...mapState(["userObj"]),
  },
  methods: {
    copyLink() {
      var copyText = document.getElementById("ref-link2");

      /* Select the text field */
      copyText.disabled = false;
      copyText.select();
      copyText.setSelectionRange(0, 99999); /*For mobile devices*/

      /* Copy the text inside the text field */
      document.execCommand("copy");
      copyText.disabled = true;
      
      this.isCopied = true;

      this.$store.commit(
        "openSnackbar",
        "Referral link copied to clipboard successfully"
      );

      setTimeout(() => {
        this.isCopied = false;
      }, 5000);
    },
    openPage(link) {
      window.open(link, "_blank");
    },
  },
};
</script>
